"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const antd_1 = require("complex-component/antd");
const complex_plugin_1 = require("complex-plugin");
const complex_utils_1 = require("complex-utils");
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectModal',
    components: {
        ComplexAutoModal: antd_1.ComplexAutoModal,
        ComplexAutoText: antd_1.ComplexAutoText
    },
    data() {
        return {
            select: null,
            next: null,
            option: {}
        };
    },
    computed: {
        list() {
            if (this.select) {
                return this.select.getList();
            }
            else {
                return [];
            }
        }
    },
    methods: {
        show(title, select, next, option = {}) {
            this.select = select;
            this.next = next;
            this.option = option;
            this.$refs.modal.show(title);
        },
        emit(val) {
            const res = this.next(val);
            if ((0, complex_utils_1.isPromise)(res)) {
                res.then(() => {
                    this.$refs.modal.hide();
                });
            }
            else if (res !== false) {
                this.$refs.modal.hide();
            }
        },
        onChoice(val) {
            if (this.option.notice === false) {
                this.emit(val);
            }
            else if (this.option.notice === true || !this.option.notice) {
                complex_plugin_1.notice.confirm(`是否选择${val.label}？`, '确认', act => {
                    if (act === 'ok') {
                        this.emit(val);
                    }
                });
            }
            else {
                complex_plugin_1.notice.confirm(this.option.notice(val), '确认', act => {
                    if (act === 'ok') {
                        this.emit(val);
                    }
                });
            }
        }
    }
});
